import { Grid, makeStyles, Typography } from '@material-ui/core';
import React from 'react';
import { presentFormatedData } from '../functionalComponents/dataFormatFunctions';

const useStyles = makeStyles((theme) => ({
  title: {
    fontWeight: 500,
    fontSize: '1.5rem',
    textAlign: 'left',
    paddingBottom: '0.3rem',
  },

  font: {
    fontWeight: 500,
    // padding: '0.5rem 0.5rem 0.5rem 0rem',
    textAlign: 'initial',
  },
  fontPadding: {
    // padding: '0.5rem 0.5rem 0.5rem 0rem',
    textAlign: 'initial',
    overflow: 'auto',
  },
  button: {
    backgroundColor: 'transparent',
    textAlign: 'end',
    paddingTop: '1rem',
  },
  borders: {
    border: '2px solid #707070',
    display: 'flex',
    width: '1.6rem',
    backgroundColor: 'grey',
  },
  files: {
    boder: '1px solid #707070',
    backgroundColor: '#F7F7F7',
    textAlign: 'center',
    padding: '2rem',
  },
  grid: {
    paddingBottom: '2rem',
    paddingTop: '1rem',
    paddingRight: '1.5rem',
  },
  closeText: {
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    color: 'blue',
    textDecoration: 'underline',
  },
  document: {
    display: 'flex',
    alignItems: 'center',
  },
}));

const BatchDetails = (props) => {
  const classes = useStyles();

  const {
    qualityAssuranceInfo,
    POBatchRecordDetails,
    asnDetails,
    receivedQuantityInfo,
  } = props;

  return (
    <React.Fragment>
      <Grid container>
        <Grid item xs={12} sm={12} md={12} className={classes.grid}>
          <Typography variant='h4' className={classes.title}>
            Batch Details
          </Typography>
          <span className={classes.borders}></span>
        </Grid>

        <Grid item xs={12} sm={4} className={classes.grid}>
          <Typography variant='body2' className={classes.font}>
            Supplier Batch Number
          </Typography>
          <Typography variant='body2' className={classes.fontPadding}>
            {/* {presentFormatedData(
              qualityAssuranceInfo?.analyticalReportNumber,
              'NA'
            )} */}
            {presentFormatedData(qualityAssuranceInfo?.batchNumberQA, 'NA')}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={4} className={classes.grid}>
          <Typography variant='body2' className={classes.font}>
            MRN Number
          </Typography>
          <Typography variant='body2' className={classes.fontPadding}>
            {presentFormatedData(POBatchRecordDetails?.numberMRN, 'NA')}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={4} className={classes.grid}></Grid>

        {/* Row 2 */}
        <Grid item xs={12} sm={4} className={classes.grid}>
          <Typography variant='body2' className={classes.font}>
            ASN Batch Quantity
          </Typography>
          <Typography variant='body2' className={classes.fontPadding}>
            {presentFormatedData(asnDetails?.asnBatchQuantity, 'NA')}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={4} className={classes.grid}>
          <Typography variant='body2' className={classes.font}>
            Actual Quantity Received
          </Typography>
          <Typography variant='body2' className={classes.fontPadding}>
            {presentFormatedData(
              receivedQuantityInfo?.actualQuantityReceived,
              'NA'
            )}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={4} className={classes.grid}></Grid>

        {/* Row 3 */}
        <Grid item xs={12} sm={4} className={classes.grid}>
          <Typography variant='body2' className={classes.font}>
            Quantity Received Date
          </Typography>
          <Typography variant='body2' className={classes.fontPadding}>
            {POBatchRecordDetails?.materialReceivedDate
              ? presentFormatedData(
                  new Date(POBatchRecordDetails?.materialReceivedDate)
                    .toLocaleDateString('en-GB', {
                      day: '2-digit',
                      month: 'short',
                      year: 'numeric',
                    })
                    .replace(/ /g, '-'),
                  'NA'
                )
              : 'NA'}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={4} className={classes.grid}>
          <Typography variant='body2' className={classes.font}>
            Date of Expiration
          </Typography>
          <Typography variant='body2' className={classes.fontPadding}>
            {qualityAssuranceInfo?.expirationDate
              ? presentFormatedData(
                  new Date(qualityAssuranceInfo?.expirationDate)
                    .toLocaleDateString('en-GB', {
                      day: '2-digit',
                      month: 'short',
                      year: 'numeric',
                    })
                    .replace(/ /g, '-'),
                  'NA'
                )
              : 'NA'}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={4} className={classes.grid}>
          <Typography variant='body2' className={classes.font}>
            Date of Manufacturing
          </Typography>
          <Typography variant='body2' className={classes.fontPadding}>
            {qualityAssuranceInfo?.materialManufactureDate
              ? presentFormatedData(
                  new Date(qualityAssuranceInfo?.materialManufactureDate)
                    .toLocaleDateString('en-GB', {
                      day: '2-digit',
                      month: 'short',
                      year: 'numeric',
                    })
                    .replace(/ /g, '-'),
                  'NA'
                )
              : 'NA'}
          </Typography>
        </Grid>
      </Grid>
    </React.Fragment>
  );
};

export default BatchDetails;
